import React from "react";
import { Header, Footer } from "../Components/PageSections";
import AppState from "js/stores/AppState";

export default function App({
  children,
  hasHeader = true,
  hasFooter = true,
  pageName = 'NEW'
}) {
  const [showScrollButton, setShowScrollButton] = React.useState(false);

  React.useEffect(async () => {
    await AppState.setCurrentPage(pageName)
  }, [])

  React.useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY;
      const threshold = window.innerHeight * 2.1;
      setShowScrollButton(scrolled > threshold);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className="new-pod-ui tw-min-h-screen tw-bg-white tw-text-black dark:tw-bg-gray-900 dark:tw-text-white">
      {hasHeader && <Header />}

      {children}

      <div className={`${showScrollButton ? 'tw-fixed' : 'tw-hidden'} bottom-10 right-5 md:right-10 tw-transition-all tw-z-50`}>
        <button
          onClick={toTop}
          className="tw-rounded-full tw-bg-gray-400 tw-text-white tw-w-14 tw-h-14 tw-flex tw-items-center tw-justify-center tw-shadow-lg hover:tw-bg-gray-500 tw-transition-colors"
          aria-label="Scroll to top"
          style={{ border: '1px #9ca3af solid' }}>
          <svg width="28" height="42" viewBox="0 0 28 42" fill="none" xmlns="http://www.w3.org/2000/svg" className="tw-w-6 tw-h-6">
            <path d="M14 3.66797L15.4142 2.25376L14 0.83954L12.5858 2.25375L14 3.66797ZM12 39.668C12 40.7725 12.8954 41.668 14 41.668C15.1046 41.668 16 40.7725 16 39.668L12 39.668ZM27.4142 14.2538L15.4142 2.25376L12.5858 5.08218L24.5858 17.0822L27.4142 14.2538ZM12.5858 2.25375L0.585792 14.2538L3.41422 17.0822L15.4142 5.08218L12.5858 2.25375ZM12 3.66797L12 39.668L16 39.668L16 3.66797L12 3.66797Z" fill="white" />
          </svg>
        </button>
      </div>

      {hasFooter && <Footer />}
    </div>
  );
}
